import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line } from 'react-chartjs-2'

import { ContainerChart } from '../ContainerChart/ContainerChart'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

interface RoundedLineChartProps {
  datasetsLabels: string[]
  datasetsTargetData: number[]
  datasetsData: number[]
  chartTitle: string
}

const RoundedLineChart: React.FC<RoundedLineChartProps> = ({
  datasetsLabels,
  datasetsTargetData,
  datasetsData,
  chartTitle
}) => {
  return (
    <ContainerChart>
      <Line
        options={{
          elements: {
            line: {
              tension: 0.3
            }
          },
          plugins: {
            legend: {
              position: 'top' as const
            },
            title: {
              align: 'start',
              display: true,
              font: {
                size: 16
              },
              text: chartTitle
            }
          },
          responsive: true
        }}
        data={{
          datasets: [
            {
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              borderColor: 'rgba(255, 99, 132, 1)',
              capBezierPoints: false,
              data: datasetsTargetData,
              fill: true,
              label: 'Meta'
            },
            {
              backgroundColor: 'rgba(53, 162, 235, 0.2)',
              borderColor: 'rgba(53, 162, 235, 1)',
              data: datasetsData,
              fill: true,
              label: chartTitle
            }
          ],
          labels: datasetsLabels
        }}
      />
    </ContainerChart>
  )
}

export default RoundedLineChart
